import Button from "../../../components/shared/Button";
import { Link } from "react-router-dom";
import Rating from "../../Rating/Rating";
import PdfViewerDownloader from "../../../components/shared/BookDownload";
import { eachInstrutor } from "../../../components/routes/path";
import { formatAmount } from "../../../utils/formatAmount";

const Card2 = ({
  bookImage,
  bookCaterory,
  bookTitle,
  ratings,
  bookPrice,
  to,
  toCategory,
  pdfUrl,
  fileName,
}) => {
  return (
    <div className="rounded-lg overflow-hidden shadow flex flex-col justify-between bg-blue-50">
      <div className="relative ">
        <Link to={to}>
          <img src={bookImage} alt="" className="" />
        </Link>
        <Link to={toCategory} className="absolute right-0 bottom-5">
          <Button
            btnBgColor={
              "bg-[#004C97] hover:bg-white hover:border hover:border-[#333333] "
            }
            btnColor={" text-white hover:text-[#333333]"}
            btnText={bookCaterory}
            padding={"px-5 py-2 transition-all  ease-in-out"}
          />
        </Link>
      </div>
      <div className="p-3 space-y-3">
        <Link
          className="hover:text-[#004C97] text-[#BCC6CC ]"
          to={eachInstrutor}
        >
          Prof Yusstore
        </Link>
        <Link to={to}>
          <h2 className="text-3xl hover:text-[#004C97] sm:font-bold sm:text-lg">
            {bookTitle}
          </h2>
        </Link>

        <div>
          <Rating ratings={ratings} />
        </div>
        <div className="flex flex-col border-t">
          <p>&#8358; {formatAmount(bookPrice)}</p>
          <Link to={to}>
            <PdfViewerDownloader pdfUrl={pdfUrl} fileName={fileName} />

            {/* <Button
              btnBgColor={
                "bg-[#004C97] hover:bg-white hover:border hover:border-[#333333]"
              }
              btnColor={" text-white hover:text-[#333333]"}
              btnText={"Read more"}
              padding={"px-5 py-2 transition-all  ease-in-out"}
            /> */}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card2;
